import {
  GET_INVOICE_CONFIG_SUCCESS,
  GET_INVOICE_CONFIG_FAILED,
  RESET_GET_INVOICE_CONFIG,
  LOADING_GET_INVOICE_CONFIG,
  NETWORK_ERROR_GET_INVOICE_CONFIG,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GET_INVOICE_CONFIG:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GET_INVOICE_CONFIG_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GET_INVOICE_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GET_INVOICE_CONFIG:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GET_INVOICE_CONFIG:
      return (state = initialState);
    default:
      return state;
  }
};
